import { render, staticRenderFns } from "./CardUnavailableMessage.vue?vue&type=template&id=02736b01&scoped=true&v-if=%24validateText(text)&"
import script from "./CardUnavailableMessage.vue?vue&type=script&lang=js&"
export * from "./CardUnavailableMessage.vue?vue&type=script&lang=js&"
import style0 from "./CardUnavailableMessage.vue?vue&type=style&index=0&id=02736b01&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02736b01",
  null
  
)

export default component.exports